import React from 'react';
import {injectIntl} from 'react-intl';

const TextField = ({intl, settings, onChange}) => {
  const {name, state, errors, label, placeholder, description, required = true} = settings || {};

  const renderLabel = () => {
    if (!label) {
      return '';
    }

    return (
      <label className="form-group__label" htmlFor={name}>
        {intl.formatMessage({id: label})}
        {!required && <span className="form-group__optional"> {intl.formatMessage({id: 'FormElements.Label.Optional'})}</span>}
      </label>
    );
  };

  const renderDescription = () => {
    if (!description) {
      return '';
    }
    return (
      <div className="form-group__message">{intl.formatMessage({id: description})}</div>
    );
  };

  return (
    <div className={`form-group ${errors[name] ? 'form-group--error' : ''}`}>
      {renderLabel()}
      <div className="form-group__input">
        <input
          type="text"
          name={name}
          placeholder={intl.formatMessage({id: placeholder})}
          onChange={onChange} value={state[name] ?? ''}
          required={required}/>
      </div>
      {renderDescription()}
      {
        errors[name] &&
        <div className="form-group__feedback">
          {errors[name]}
        </div>
      }
    </div>
  );
};

export default injectIntl(TextField);
